module.exports = __webpack_public_path__ + "img/elite-logo.5b7668ef.svg";